<template>
    <div class="container-fluid pt-5 pb-5">
        <div class="container mt-5">
            <div
                class="row justify-content-between direction-reverse pt-5 pb-3"
            >
                <div class="col-md-6 my-auto">
                    <div class="my-5">
                        <h1 class="fw-bold text-c-secondary display-6">
                            {{ localise("error", "title") }}
                        </h1>
                        <p class="text-muted mt-3">
                            {{ localise("error", "text") }}
                        </p>
                        <div class="pt-3">
                            <router-link
                                to="/"
                                class="btn btn-c-secondary rounded-c-3 px-4 py-3 text-white shadow mt-2"
                            >
                                <i class="fas fa-angle-left"></i>
                                <span class="ms-2">{{
                                    localise("error", "button")
                                }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <img
                        class="w-100 h-100 rounded-c-3 animation"
                        src=""
                        alt="image"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import translations from "../helpers/translations";

export default {
    name: "NotFound",
    methods: {
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
    },
    mounted() {
        document.title = this.localise("error", "title");
        document
            .querySelector('meta[name="description"]')
            .setAttribute("content", this.localise("error", "text"));
    },
    updated() {
        document.title = this.localise("error", "title");
        document
            .querySelector('meta[name="description"]')
            .setAttribute("content", this.localise("error", "text"));
    },
};
</script>

<style scoped>
@media (max-width: 475px) {
    .direction-reverse {
        flex-direction: column-reverse;
    }
}
</style>
